export const walletShorter = (wallet) =>{
    if (wallet){
        return wallet.slice(0, 5) + "..." + wallet.slice(-5);
    } else {
        return null
    }
}